import React from "react";
import classNames from "classnames";

type NavigationBadgeProps = {
  totalCount: number;
  muted: boolean;
};

const NavigationBadge = ({ totalCount, muted }: NavigationBadgeProps) =>
  totalCount > 0 ? (
    <span
      data-testid="navigation-badge"
      className={classNames(
        "px-[5px] rounded-full",
        "inline-flex items-center shrink-0 justify-center",
        "text-xs",
        { "text-tw-secondary-500": muted },
        { "bg-danger text-lightest": !muted },
      )}
    >
      {totalCount}
    </span>
  ) : null;

export default NavigationBadge;
